import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/ecommerce.jpg";
import projImg2 from "../assets/img/maps.jpg";
import projImg3 from "../assets/img/pokemons.jpg";
import designImg1 from '../assets/img/consultora.jpg'
import designImg2 from '../assets/img/prettypets.jpg'
import designImg3 from '../assets/img/portfolio-cris.jpg'
import challengeImg from '../assets/img/challenge.jpg'
import monitorImg from '../assets/img/monitor.png'
import timelineImg from '../assets/img/timeline-ux.jpg'
import sw_api from '../assets/img/sw_api.jpg'

import empty from "../assets/img/empty.jpg";
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import { useTranslation } from "react-i18next";

export const Projects = () => {
  const [t] = useTranslation("global");
  const developments = [
    {
      title: "Ecommerce",
      description: "Mobile App - React Native",
      imgUrl: projImg1,
      repository:'https://github.com/cristiangomezdev/s3-06-m-reactnative-node',
      deploy:'https://github.com/cristiangomezdev/s3-06-m-reactnative-node/releases'
    },
    {
      title: "Mapsbox",
      description: "Web App - React Typescript",
      imgUrl: projImg2,
      repository:'https://github.com/cristiangomezdev/maps-app',
      deploy:'https://maps-app-cristian-gomez.netlify.app'
    },
    {
      title: "PokemonApi",
      description: "Web App - Next Typescript",
      imgUrl: projImg3,
      repository:'https://github.com/cristiangomezdev/pokemon-next',
      deploy:'https://pokemonapi-next-kaa14ffrz-cristophh123.vercel.app'
    }
  ];
  const design = [
    {
      title: "Consultora",
      description: "UX / UI",
      imgUrl: designImg1,
      behance:'https://www.behance.net/gallery/154645791/Estudio/modules/872633057',

    },
    {
      title: "PrettyPets",
      description: "Logo / Icon / etc",
      imgUrl: designImg2,
      behance:'https://www.behance.net/gallery/151971461/Pretty-Pets/modules/857884335'
    },
    {
      title: "Cris-portfolio",
      description: "Logo / UX / UI ",
      imgUrl: designImg3,
      behance:'https://www.behance.net/gallery/154728187/Portfolio/modules/873270561'
    }
  ];
  const challenge = [
    {
      title: "Blogr landing page",
      description: "HTML, CSS & JS",
      imgUrl: challengeImg,
      repository:'https://github.com/cristiangomezdev/Blogr-landing-page'
    },
    {
      title: "Timeline",
      description: "HTML & CSS",
      imgUrl: timelineImg,
      repository:'https://github.com/cristiangomezdev/challenge-timeline.css'
    },
    {
      title: "Swapi (star wars api)",
      description: "React / Tailwind / star wars",
      imgUrl:sw_api,
      repository:'https://github.com/cristiangomezdev/IT4W',
      deploy:'https://it-4-w.vercel.app'
      
    }
  ];
  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>

                <div className="square-display"></div>
                
                <img src={monitorImg} style={{
                  width:'200px',
                  display:'block',
                  margin:'0px auto',
                  zIndex
              :'1'}} alt="Deploy"/>
                <h2 style={{marginTop:'50px'}}>{t("projects.title")}</h2>
                <p>{t("projects.instructions")}</p>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">{t("projects.development")}</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">{t("projects.design")}</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">{t("projects.challenge")}</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                    <Tab.Pane eventKey="first">
                      <Row>
                        {
                          developments.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="second">
                    <Row>
                        {
                          design.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
                      
                     {/*  <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque quam, quod neque provident velit, rem explicabo excepturi id illo molestiae blanditiis, eligendi dicta officiis asperiores delectus quasi inventore debitis quo.</p> */}
                      <Row>
                        {
                          challenge.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      
    </section>
  )
}
